import { render, staticRenderFns } from "./LoginFail.vue?vue&type=template&id=967d19d4&scoped=true"
import script from "./LoginFail.vue?vue&type=script&lang=js"
export * from "./LoginFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967d19d4",
  null
  
)

export default component.exports